import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link as RouterLink } from 'react-router-dom';

import MenuIcon from '@mui/icons-material/Menu';
import { AppBar, Box, Hidden, IconButton, Toolbar } from '@mui/material/';
import boltLogoImg from '@provider-portal/common/assets/icons/bolt-logo.svg';

import { selectProviderAction, selectSelectedVendorAndProvider } from 'rdx/account';

import { Provider } from 'components/TopBar/Provider';

import Account from './Account';

interface TopBarProps {
  onMobileNavOpen: () => void;
}

export const TopBar: React.FC<TopBarProps> = ({ onMobileNavOpen }) => {
  const dispatch = useDispatch();

  const selectedProvider = useSelector(selectSelectedVendorAndProvider);
  const onProviderSelect = useCallback(
    (_vendorId: number, _vendorName: string, providerId: number, _providerName: string) => {
      dispatch(selectProviderAction(providerId));
    },
    [dispatch],
  );

  return (
    <AppBar position="relative">
      <Toolbar sx={{ pl: { xs: 1.5, lg: 3 } }}>
        <Hidden xlUp>
          <Box>
            <IconButton onClick={onMobileNavOpen}>
              <MenuIcon />
            </IconButton>
          </Box>
        </Hidden>
        <Hidden xlDown>
          <Box mt={1}>
            <RouterLink to="/">
              <img src={boltLogoImg} alt="Bolt Food" />
            </RouterLink>
          </Box>
        </Hidden>
        <Box ml={2} flexGrow={1} />
        <Provider
          selectedProvider={selectedProvider}
          onProviderSelect={onProviderSelect}
          displayAllLocationsOption={false}
          useKalepMainComponent={false}
        />
        <Account />
      </Toolbar>
    </AppBar>
  );
};
